import type * as React from 'react';

import { cn } from '../../styles/lib/utils';
import { Text } from '../Text';

type FileRowProps = React.ComponentProps<'div'> & {
  name: string;
  action?: React.ReactNode;
};

function FileRow({ name, action, className, ...props }: FileRowProps) {
  return (
    <div
      {...props}
      data-slot="file-row"
      className={cn('flex items-center justify-between gap-2 rounded-[8px] border border-grey-30 p-2', className)}
    >
      <Text className="block min-w-0 truncate text-sm font-medium text-primary" title={name}>
        {name}
      </Text>
      {action}
    </div>
  );
}

export { FileRow };
export type { FileRowProps };
